/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import type { APIProps as TableBarProps } from '@atlassian/jira-software-deployments-common-table/src/components/table/components/bar/view.tsx';
import { CHART_BAR_Z_INDEX } from '@atlassian/jira-software-deployments-common-table/src/styles/z-index';
import { useTimelineMode } from '../../../controllers/timeline-mode';
import { useIssueDeployments } from '../../../services/core-data/main.tsx';
import { DEFAULT_VIEW_CONFIGURATION_PREFERENCE } from '../../../services/my-preference/constants.tsx';
import { useIconsConfigurationPreference } from '../../../services/my-preference/main.tsx';
import Circles from './circles';
import Lines from './lines';

const DeploymentsBar = ({ id: issueId, getPositionFromDate }: TableBarProps) => {
	const [timelineMode] = useTimelineMode();
	const deploymentsResult = useIssueDeployments(issueId);

	const iconsConfig = useIconsConfigurationPreference();

	return (
		<>
			{deploymentsResult.data && deploymentsResult.data.length > 0 && (
				<div css={wrapperStyles}>
					<Lines
						deployments={deploymentsResult.data}
						timelineMode={timelineMode}
						getPositionFromDate={getPositionFromDate}
					/>
					<Circles
						deployments={deploymentsResult.data}
						timelineMode={timelineMode}
						issueId={issueId}
						showMultipleDeploymentsIcon={
							iconsConfig?.showMultipleDeploymentsIcon ??
							DEFAULT_VIEW_CONFIGURATION_PREFERENCE.icons.showMultipleDeploymentsIcon
						}
						getPositionFromDate={getPositionFromDate}
					/>
				</div>
			)}
		</>
	);
};

const wrapperStyles = css({
	position: 'absolute',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: CHART_BAR_Z_INDEX,
	height: '100%',
	width: '100%',
	display: 'flex',
	alignItems: 'center',
});

export default DeploymentsBar;
